const state = {
    namespaced: true,
    state: {
        TOKEN: '',
        OPENID: '',
        UNIONID: '',
        AVATAR: '',
        CITY: '',
        COUNTRY: '',
        INVITATION_CODE: '',
        NICKNAME: '',
        PROVINCE: '',
        SEX: null,
        MSG: 0,
        CELLPHONE: null,
    },
    getters: {},
    mutations: {
        SET_STATE(state, { key, value }) {
            state[key] = value;
        },
        SET_STATES(state, list) {
            list.forEach(({ key, value }) => (state[key] = value));
        },
    },
    actions: {},
};

export default state;
